const CURR = 'RM';
export const APP_LOCALE = 'en-GB';

// Loan Scheme
export const SCHEME = {
	EPF: 'EPF',
	HUTANG: 'HUTANG',
	A: 'A',
	D: 'D',
	F: 'F',
	P: 'P'
} as const;

export const FORMJ_SCHEME = {
	EPF: 'EPF-1.0',
	SWASTA: 'SWASTA-1.0'
} as const;

export type FormJScheme = (typeof FORMJ_SCHEME)[keyof typeof FORMJ_SCHEME];

export const ALERT_TYPE = {
	SUCCESS: 1,
	DANGER: 2
} as const;

// #region 'Alert Messages'
export const SUCCESS_MESSAGES = {
	ADDED: (type: string) => `Successfully added ${type}!`,
	UPDATED: (type: string) => `Successfully updated ${type}!`,
	ACTION: (action: string, type: string) => `Successfully ${action} ${type}!`,
	ADDED_FOR: (type: string, name: string) => `Successfully added ${type} for ${name}!`,
	UPDATED_FOR: (type: string, name: string) => `Successfully updated ${type} for ${name}!`,
	DELETED: (type: string) => `Successfully deleted ${type}!`,
	ACTION_FOR: (action: string, type: string, name: string) => `Successfully ${action} ${type} for ${name}!`
} as const;
// #endregion

// #region 'Error Messages'
export const ERROR_MESSAGES = {
	MISSING_FIELDS: 'Please fill in all necessary fields',
	INVALID_FIELDS: 'Please fill in all necassary fields CORRECTLY',
	INVALID_BANK_ACCOUNT: 'Invalid account number, please check its length and format',
	EMPTY_FIELD: (field: string) => `${field} cannot be empty`,
	INVALID_FIELD: (field: string) => `Please enter a valid ${field}`,
	EMPTY_SELECTION: (field: string) => `Please select a ${field}`,
	NEGATIVE_NUMBER: (field: string) => `${field} cannot be negative`,
	MINIMUM_CURRENCY: (field: string, min: number) => `⚠️ ${field} cannot be less than ${CURR}${min}`,
	NOT_MATCH: (field1: string, field2: string) => `${field1} NOT match ${field2}`,
	NOT_IN_DATE_RANGE: (field: string, minDate: string, maxDate: string) => `${field} must within ${minDate} and ${maxDate}`,
	EXCEED_DATE: (field: string, maxDate: string) => `${field} cannot exceed ${maxDate}`
} as const;

export const LOAN_ERROR_MESSAGES = {
	MANUAL_KEY_IN: '⌨️ THIS IS MANUAL KEY IN FIRST LOAN, NOT SYSTEM GENERATE',
	MULTIPLE_OF: (field: string, multiple: number) => `Please make sure ${field} is MULTIPLE of ${multiple}`,
	FIXED_VALUE_CURRENCY: (field: string, value: number) => `Please make sure you key in ${CURR}${value} for ${field} when adding loan`,
	FIRST_LOAN_LIMIT: (termLowerLimit: number, termUpperLimit: number, firstLoanPercentage: number, firstLoanLimit: number) =>
		`🚨 Loan borrow within term ${termLowerLimit} - ${termUpperLimit} can only borrow ${firstLoanPercentage}% of epf amount on FIRST LOAN. In this case = ${CURR}${firstLoanLimit}`,
	EXTRA_LOAN_LIMIT: (
		termLowerLimit: number,
		termUpperLimit: number,
		overallLoanPercentage: number,
		maxPrincipal: number,
		previousLoanPrincipal: number,
		currentLoanPrincipal: number
	) =>
		`🚨 Loan borrow within term ${termLowerLimit} - ${termUpperLimit} can only borrow ${overallLoanPercentage}% of epf amount IN TOTAL. In this case: Limit = ${CURR}${maxPrincipal} | User = ${CURR}${previousLoanPrincipal + currentLoanPrincipal} (Previous: ${CURR}${previousLoanPrincipal} + ${CURR}${currentLoanPrincipal})`,
	SETTLEMENT_LIMIT: (
		termLowerLimit: number,
		termUpperLimit: number,
		maxSettlementPercentage: number,
		maxSettlement: number,
		previousSettlement: number,
		currentSettlement: number
	) =>
		`🚨 Loan borrow within term ${termLowerLimit} - ${termUpperLimit} can only borrow ${maxSettlementPercentage}% of SETTLEMENT RATIO IN TOTAL. In this case: Limit = ${CURR}${maxSettlement} | User = ${CURR}${(previousSettlement + currentSettlement).toFixed(2)} (Previous: ${CURR}${previousSettlement.toFixed(2)} + ${CURR}${currentSettlement.toFixed(2)})`,
	NOT_EQUAL_PERMITTED_SETTLEMENT_CHARGES: (field: string, value: number, permitted_value: number, term: number) =>
		`🚨 Settlement ${field} ${CURR}${value} is not equal to permitted Settlement ${field}: ${CURR}${permitted_value} (${CURR}${(permitted_value / term).toFixed(2)} x ${term})`
} as const;
// #endregion

// #region 'Error Remarks'
export const ERROR_REMARKS = {
	MINIMUM_CURRENCY: (field: string, min: number) => `${field} less than ${CURR}${min}`
} as const;
// #endregion

// File Type
export const FILE_TYPE = {
	IMAGE: 0,
	VIDEO: 1,
	PDF: 2,
	OTHER: 3
} as const;

// DialogItem content injection type
export const INJECT_TYPE = {
	COMPONENT: 0,
	TEMPLATE: 1 // raw html
} as const;

export const MAINTAIN_BIZ_TAB = {
	BUSINESS: 0,
	LICENSE: 1,
	FYINFO: 2
} as const;

//Customer Docuseal type
export const CUSTOMER_DOCUSEAL_TYPE = {
	SETTLEMENT_BREAKDOWN: 'settlementBreakdown',
	ACCOUNT_AUTHORIZATION: 'accountAuthorizationLetter'
} as const;
